import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import SignUp from '@/components/SignUp'
import Services from '@/components/Services'
import Test from '@/components/test'
import firebase from '../firebase'

Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'services',
      component: Services,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/test',
      name: 'test',
      component: Test
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/sign-up',
      name: 'signup',
      component: SignUp
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = firebase.app.auth().currentUser

  console.log(currentUser)

  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)

  if (requiresAuth && !currentUser) {
    next('login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js